import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable} from 'rxjs/Observable'

@Injectable()
export class jcService {

    menuItems: Observable<any>;
    gaugeVal: AngularFireList<any>;
    newGauge: any;

    constructor(private af: AngularFireDatabase, private afs: AngularFirestore) { }

    getZones() {

        this.menuItems = this.af.list('/menu').valueChanges();
        console.log(this.menuItems);
        return this.menuItems;

    }

    getGaugeVal() {
        return this.af.object('/list');

    }

    getGaugeInfo() {

        return this.af.object('/gauge');
    }

    getAreaInfo() {
        // return this.af.object<any>('/area', { preserveSnapshot: true});
        const itemRef = this.af.object('/area');
        return itemRef.snapshotChanges().subscribe();

    }

    // getAreaStatus() {
    //     return this.af.list('/customer1/areas').valueChanges();
    // }

    getAreaStatus() {
        return this.afs.collection('areas');
        //prodobs = this.prodcollection.valueChanges();

        //racesCollection: AngularFirestoreCollection<any>;

    }

    getAreaDetail() {
        const assm1 = this.afs.collection('areas/Assembly 1/devices');
        const paint1 = this.afs.doc('areas/Paint 1/devices');
        paint1.update(assm1);

    }

    getAreaList() {
        return this.af.list('/areaList');

    }

    getAlerts() {
        return this.af.list('/customer1/alerts').valueChanges();
    }

    updateAlert(alertID: any, state: any) {
        const alert = this.af.list('/customer1/alerts');
        alert.update(alertID, {acknowledged: state});
    }

    getAreaSensors(area: any) {
        return this.af.list('/area/' + area + '/sensors').valueChanges();
    }

    // First try for filtering
    // getTestSensors(areaName) {
    //     return this.af.list('/sensors', {
    //         query: {
    //             orderByChild: 'area',
    //             equalTo: areaName
    //         }
    //     });
    // }
    getTestSensors() {
        return this.af.list('/sensors').valueChanges();
    }

    setAreaStatus(areaToUpdate: any, status: any) {
        const area = this.af.list('/customer1/areas');
        area.update(areaToUpdate, {status: status});
        // return this.af.list('/customer1/areas');
    }

    // pollErrors() {
    //     return this.af.list('/sensors', {
    //         query: {
    //             orderByChild: 'area',
    //             equalTo: 'red'
    //         }
    //     });
    // }
    // pollWarnings() {
    //     return this.af.list('/sensors', {
    //         query: {
    //             orderByChild: 'area',
    //             equalTo: 'yellow'
    //         }
    //     });
    // }

    pollAlerts() {

        // return this.af.list('/customer1/alerts', {
        //     query: {
        //         orderByChild: 'area'
        //     }
        // });

        return this.af.list('/customer1/alerts', ref => ref.orderByChild('area'));

    }
}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/jc-services/jc-services.service.ts